module.exports = __webpack_public_path__ + "static/13_Microsoft-4c980a1660e6265f2b8b6454675e4b14.png";